<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-organisation-activities">
  <div class="org-admin-organisation-activities--layout">
    <app-org-admin-sidebar class="org-admin-organisation-activities--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-organisation-activities--content">
      <app-page-header></app-page-header>
      <app-activities [showTabs]="true" [useAdminAuditingApi]="true" class="activities--container"></app-activities>
    </div>
  </div>
</div>

